import { apiPost, apiGet } from '@/lib/api-client';
import type {
  SaveBrandingRequest,
  SaveBrandingResponse,
  GetBrandingResponse,
} from '@shared/types/dashboard';

export const saveBranding = async (request: SaveBrandingRequest): Promise<SaveBrandingResponse> => {
  const response = await apiPost<SaveBrandingResponse>('/api/branding/save', request);
  return response.data || response as SaveBrandingResponse;
};

export const getBranding = async (shop: string): Promise<GetBrandingResponse> => {
  const response = await apiGet<GetBrandingResponse>(`/api/branding?shop=${encodeURIComponent(shop)}`);
  return response.data || response as GetBrandingResponse;
};

